import React from 'react';

interface SegmentTableSkeletonProps {
  rows?: number;
}

const SegmentTableSkeleton: React.FC<SegmentTableSkeletonProps> = ({ rows = 10 }) => {
  return (
    <div className="p-8">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between mb-4">
        <div className="h-8 bg-gray-200 rounded animate-pulse w-32"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-40"></div>
      </div>

      {/* Filter Controls Skeleton */}
      <div className="flex items-center gap-2 mb-3">
        <div className="h-10 bg-gray-200 rounded animate-pulse w-60"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-32"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-28"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-28"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-24"></div>
        <div className="h-10 bg-gray-200 rounded animate-pulse w-32"></div>
      </div>

      {/* Table Skeleton */}
      <div className="overflow-x-auto bg-white rounded-lg border border-gray-200">
        <table className="w-full text-sm mt-4">
          <thead>
            <tr className="text-gray-400 text-xs border-b border-gray-200">
              <th className="py-2 px-2 text-left">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-12"></div>
              </th>
              <th className="py-2 px-2 text-left">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-12"></div>
              </th>
              <th className="py-2 px-2 text-left">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
              </th>
              <th className="py-2 px-2 text-left">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-12"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, index) => (
              <tr key={index} className="border-b last:border-0 hover:bg-gray-50">
                <td className="py-2 px-2 min-w-[180px]">
                  <div className="flex flex-col gap-2">
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-48"></div>
                  </div>
                </td>
                <td className="py-2 px-2">
                  <div className="h-6 bg-gray-200 rounded-full animate-pulse w-16"></div>
                </td>
                <td className="py-2 px-2">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                </td>
                <td className="py-2 px-2">
                  <div className="flex items-center gap-2">
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-12"></div>
                    <div className="flex gap-1">
                      <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                      <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Skeleton */}
      <div className="flex items-center justify-between mt-6">
        <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
          <div className="w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default SegmentTableSkeleton; 